"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var MarqueeSelection_base_1 = require("./MarqueeSelection.base");
var MarqueeSelection_styles_1 = require("./MarqueeSelection.styles");
exports.MarqueeSelection = Utilities_1.styled(MarqueeSelection_base_1.MarqueeSelectionBase, MarqueeSelection_styles_1.getStyles);
//# sourceMappingURL=MarqueeSelection.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/MarqueeSelection/MarqueeSelection.js
// module id = 1601
// module chunks = 0